import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { PropTypes } from 'prop-types';
import { Modal } from 'react-bootstrap';
import { getUser } from '../../auth/selectors';
import LoadingComponent from '../../../common/LoadingComponent';
import { TextField } from '@material-ui/core';
import { updateSegmentNotesRequested } from '../actions';
import { getSegmentNotesLoading } from '../selectors';
import './styles.scss';

function SegmentNotes({
    show,
    segmentId,
    loading,
    segmentNotes,
    onClose,
    saveNotes,
    segments,
    user,
}) {
    const [notes, setNotes] = useState('');
    const [isEditing, setIsEditing] = useState(false);
    const segment = segments.find((seg) => seg.id == segmentId);
    const segmentCreatedByUser = segment && segment.userId == user.id;
    const charLeft = 256 - notes.length;
    const charOverflow = notes.length > 256;
    useEffect(() => {
        if (!loading) {
            setIsEditing(false);
        }
    }, [loading]);

    useEffect(() => {
        setNotes(segmentNotes || '');
    }, [segmentNotes]);

    const loader = <LoadingComponent isLoading={loading} />;
    return (
        <div>
            <Modal
                size="lg"
                onHide={() => {
                    onClose();
                    setIsEditing(false);
                    setNotes(segmentNotes);
                }}
                backdrop="static"
                show={show}
                aria-labelledby="simple-modal-title"
                aria-describedby="simple-modal-description"
                className="segment-notes-modal"
                centered={true}
                animation={false}
            >
                <Modal.Header closeButton>
                    <label>Note</label>
                    {segmentCreatedByUser && !isEditing && (
                        <button
                            className="edit-btn"
                            onClick={() => setIsEditing(true)}
                        >
                            Edit
                        </button>
                    )}
                    {loading && loader}
                </Modal.Header>
                <Modal.Body>
                    <TextField
                        disabled={segmentCreatedByUser ? !isEditing : true}
                        value={notes}
                        type={'text'}
                        placeholder={
                            segmentCreatedByUser
                                ? 'Enter Notes here'
                                : 'No Notes Available'
                        }
                        multiline
                        onChange={(event) => setNotes(event.target.value)}
                    />
                    {segmentCreatedByUser && isEditing && (
                        <label
                            className={`char-left ${
                                charOverflow ? 'overflow' : ''
                            }`}
                        >
                            Characters left {charLeft}
                        </label>
                    )}
                    {segmentCreatedByUser && isEditing && (
                        <div className="footer">
                            <button
                                disabled={
                                    !(notes && notes.length > 0) || charOverflow
                                }
                                onClick={() => saveNotes(segmentId, notes)}
                                className="save-btn"
                            >
                                Save
                            </button>
                            <button
                                onClick={() => {
                                    setIsEditing(false);
                                    setNotes(segmentNotes || []);
                                }}
                                className="cancel-btn"
                            >
                                Cancel
                            </button>
                        </div>
                    )}
                </Modal.Body>
            </Modal>
        </div>
    );
}

SegmentNotes.propTypes = {
    show: PropTypes.bool,
    segmentId: PropTypes.string,
    loading: PropTypes.bool,
    segmentNotes: PropTypes.string,
    onClose: PropTypes.func,
    saveNotes: PropTypes.func,
    segments: PropTypes.array,
    user: PropTypes.object,
};

SegmentNotes.defaultProps = {
    show: false,
    segmentId: null,
    loading: false,
    segmentNotes: '',
};

const mapStateToProps = (state) => {
    return {
        loading: getSegmentNotesLoading(state),
        user: getUser(state),
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        saveNotes: (segmentId, notes) =>
            dispatch(updateSegmentNotesRequested(segmentId, notes)),
    };
};

const ConnectedSegmentNotes = connect(
    mapStateToProps,
    mapDispatchToProps,
)(SegmentNotes);

export default ConnectedSegmentNotes;
